import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/native-currency-engine/page.tsx");
